import { render, staticRenderFns } from "./LenovoSelectMultiple.vue?vue&type=template&id=3b15456c"
import script from "./LenovoSelectMultiple.vue?vue&type=script&lang=js"
export * from "./LenovoSelectMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports